import {Layout, Typography, Anchor} from 'antd';
import {Content} from 'antd/lib/layout/layout';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import CWLTabs from './CWLTabs';
import GWL from './GWL';
import ModWLTabs from './ModWLTabs';
import StanWLTabs from './StanWLTabs';

const {Link} = Anchor;
const {Sider} = Layout;
const {Text} = Typography;
const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ProtocolsPage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#GWL') {
      setBackI(appColors['ColorC']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#CWL') {
      setBackI('transparent');
      setBackII(appColors['ColorC']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#ModWL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorC']);
      setBackIV('transparent');
    } else if (key === '#StanWL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorC']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#GWL' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorC'], fontSize: '2.2vh'}}>Protocols</Text></Content>}/>
          <Link href='#CWL' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorC'], fontSize: '2.5vh'}}>Characterization</Text></Content>}/>
          <Link href='#ModWL' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Modifications</Text></Content>}/>
          <Link href='#StanWL' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorC'], fontSize: '3vh'}}>Correlation</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorC'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> P&nbsp;<br/> R&nbsp;<br/> O&nbsp;<br/> T&nbsp;<br/> O&nbsp;<br/> C&nbsp;<br/> O&nbsp;<br/> L&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='GWL'>
              <GWL/>
            </div>
            <div id='CWL'>
              <CWLTabs/>
            </div>
            <div id='ModWL'>
              <ModWLTabs/>
            </div>
            <div id='StanWL'>
              <StanWLTabs/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ProtocolsPage;
